import React from 'react'
import { ChevronRightIcon, ChevronLeftIcon, TrophyIcon, ShieldCheckIcon } from '@heroicons/react/24/solid'
// import classNames from 'classnames';
import Marlon from '../assets/images/Marlon.png';
import { UserGroupIcon } from '@heroicons/react/24/solid';
import Rob from '../assets/images/Rob.png';
import Chad from '../assets/images/Chad-Poarch-2.png';
import Vector from '../assets/images/HeroVector.svg';


const cardInfoObjects = [
  {
    name: "Chad Poarch",
    position: "Proffessional Soccer Player (RW)",
    image: Chad,
    playingCareer: [
      {icon: <UserGroupIcon className="w-8" />, text: "Right Back for Charlotte Independence (USL Championship: 2018-2019)"},
      {icon: <UserGroupIcon className="w-8" />, text: "USA Youth National Team U20 Camp (2017)"},
      {icon: <UserGroupIcon className="w-8" />, text: "Collegiate D1 Soccer for University of Delaware Blue Hens (2017)"},
      {icon: <UserGroupIcon className="w-8" />, text: "Collegiate D1 Soccer for Highpoint University (2016)"},
      
    ],
    coachingCareer: [
      {icon: <ShieldCheckIcon className="w-8"/>, text: "Sporting Delaware Head Coach (2020-present)"},
      {icon: <ShieldCheckIcon className="w-8"/>, text: "US Soccer Federation “Grassroots” License"},
      
    ]
  },
  {
    name: "Marlon Trejo",
    position: "U16 Head Coach at Sporting Delaware",
    image: Marlon,
    playingCareer: [
      {icon: <UserGroupIcon className="w-8" />, text: "4 year Player at Neumann University"},
      {icon: <TrophyIcon className="w-8" />, text: "2x AEC All Conference First Team"},
      {icon: <UserGroupIcon className="w-8" />, text: "1 Year Player at West Chester United"},
      {icon: <UserGroupIcon className="w-8" />, text: "3X Delaware Premier League Champion"},
    ],
    coachingCareer: [
      {icon: <ShieldCheckIcon className="w-8"/>, text: "2 years as youth u14 coach Sporting Delaware"}
    ]
  },
  {
    name: "Rob Campbell",
    position: "Grassroots Referee",
    image: Rob,
    playingCareer: [
      {icon: <UserGroupIcon className="w-8" />, text: "2 year player at Clemson University"},
      {icon: <UserGroupIcon className="w-8" />, text: "1 Year Player at West Chester United"},
      {icon: <TrophyIcon className="w-8" />, text: "U16 USSDA Semi-Finalist"},
      {icon: <UserGroupIcon className="w-8" />, text: "3X Delaware Premier League Champion"},
    ],
    coachingCareer: [
      {icon: <ShieldCheckIcon className="w-8"/>, text: "Grassroots Coaching License"}
    ]
  },
]


const BulletPoint = ({icon, text}) => {
  return (
    <div className="flex items-center gap-3">
        <div>{icon}</div>
        <p className="text-sm">{text}</p>
      </div>
  )
}


const Card = ({staffMember}) => {
  return(
    <div className="carousel-card card overflow-hidden shadow-lg">
      <img src={staffMember.image} alt="soccer-camp" className="w-full h-48 lg:h-72 object-cover"/>
     
      <div className="px-4 pb-6">
        <div className="card-body">
          <h2 className="mb-3 text-center">{staffMember.name}</h2>
          {/* Playing Career */}
          <div className="flex flex-col gap-2 w-full">
            <h3>Playing Career</h3>
            {staffMember.playingCareer.map((element, index) => <BulletPoint key={index} {...element} />)}
          </div>
          {/* Coaching Career */}
          <div className="flex flex-col gap-2 w-full">
            <h3>Coaching Career</h3>
            {staffMember.coachingCareer.map((element, index) => <BulletPoint key={index} {...element} />)}
          </div>
        </div>
        <button className="btn-primary w-full rounded-md">Contact Coach</button>
      </div>
    </div>
  )
}


const Carousel = () => {
  
  var angle = 0;

  const rotateStaff = (sign) => { 
    const spinner = document.querySelector("#spinner");
    if (!sign) { 
      angle = angle + 120; 
    } else { 
      angle = angle - 120; 
    }
    spinner.setAttribute("style","-webkit-transform: rotateY("+ angle +"deg); -moz-transform: rotateY("+ angle +"deg); transform: rotateY("+ angle +"deg);");
  }
  
  return (
    <div id="staff" className="my-24 scroll-m-16 mb-48 w-full overflow-hidden relative">
      <div className="absolute left-0 -top-20 w-full rotate-12">
        <img src={Vector} className="h-full"></img>
      </div>
      <h1 className="text-center">Our Staff</h1>
      
      <div className="mt-20 w-full container-padding flex items-center">
        
        <button 
          className="bg-primary-500/20 hover:bg-primary-500/50 p-2 rounded-full float-left z-50" 
          onClick={() => rotateStaff(true)}
        >
          <ChevronLeftIcon className='text-white w-7 z-50 bg-secondary-900 rounded-full border border-primary-100'/>
        </button>
        
        <div className="flex gap-3 w-full justify-center items-center h-[700px] relative rotation-container">
          <div id="spinner" className="relative flex w-96 h-full spinner">
            {cardInfoObjects.map((element, index) => <Card key={index} staffMember={element}/>)}
          </div>
        </div> 
        
        <button 
          className="bg-primary-500/20 hover:bg-primary-500/50 p-2 rounded-full float-right z-50"
          onClick={() => rotateStaff(false)}
        >
          <ChevronRightIcon className='text-white w-7 z-50 bg-secondary-900 rounded-full  border border-primary-100'/>
        </button>
      </div>

      
    </div>
  )
}

export default Carousel